export const Colors = {
  black: "#262626",
  darkGray: "#737373",
  lightGray: "#b5b5b5",
  white: "#ffffff"
}
